
import FileInput from /* webpackChunkName: "FileInput" */ '~/components/file-io/FileInput'
import { SettingsIcon } from "vue-feather-icons";
import { capitalizeFirstLetter } from '~/fc/Helpers/StringHelpers'

export default {
  name: 'IndexTemplate',
  components: {
    SettingsIcon,
    FileInput,
    AdvancedOptions: () => import(/* webpackChunkName: "AdvancedOptions" */ "~/components/file-io/AdvancedOptions"),
    Accordion: () => import(/* webpackChunkName: "AccordionSingle" */ "~/components/ui/AccordionSingle")
  },
  computed: {
    info () { return this.$store.state.info },
    list () { return this.$store.state.list },
    hasFiles () { return !!this.$store.state.list.length },
    merging () { return this.$store.state.advancedSetting.merging },
    pageUid() { return this.merging ? 'root' : 'page' },
    showAdvancedOptions () {
      // (info.advancedOptions || merging) && !(hasFiles && !merging)
      if (this.hasFiles) return this.merging
      return this.info.advancedOptions
    }
  },
  created () {
    const type = this.$route.params.id.replace('-converter', '')
    this.$store.commit('updateBreadcrumbs', [{
      url: this.localePath(`/${type}-converter`),
      label: capitalizeFirstLetter(type) + ' ' + this.$t('converter')
    }])
  },
  mounted () {
    if (this.info.customVariables && this.info.customVariables.defaultTarget) {
      this.selectedTarget = this.info.customVariables.defaultTarget
      this.$store.dispatch('advancedSetting/setDefaultTarget', this.selectedTarget)
    } else {
      this.$store.dispatch('advancedSetting/setDefaultTarget', '')
    }
  }
}
